import { Paper, Stack } from "@mantine/core";
import { L2KH5, L2KText } from "../Typography";
import { PostCard } from "../../posts/PostCard";
import type { PostSummary } from "../../../types/post";

interface Props {
  related: PostSummary[];
}

export function KeepReading({ related }: Props) {
  return (
    <Paper
      withBorder
      p="md"
      radius="md"
      style={{
        position: "sticky",
        top: "var(--header-offset)",
        background: "var(--surface-bg-tint)",
        borderColor: "rgba(255, 128, 0, 0.15)",
      }}
    >
      <L2KH5 mb="sm">Keep reading</L2KH5>
      {related.length === 0 ? (
        <L2KText variant="secondary">Nothing else yet.</L2KText>
      ) : (
        <Stack gap="sm">
          {related.map((p) => (
            <PostCard key={p.id} post={p} variant="compact" />
          ))}
        </Stack>
      )}
    </Paper>
  );
}

export default KeepReading;
